var _circle, _ellipse, _rect, _rect2, _rect3, _rect4, _circle2, _circle3, _circle4, _ellipse2, _line, _line2, _path, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 180,
    viewBox: "0 0 200 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 90,
    r: 65,
    fill: "#f2f2fc"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 155,
    rx: 80,
    ry: 10,
    fill: "#e6e6fa",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 60,
    width: 70,
    height: 60,
    rx: 8,
    fill: "#5E17EB",
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 60,
    width: 70,
    height: 15,
    rx: 4,
    fill: "#5E17EB",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 45,
    width: 10,
    height: 15,
    rx: 2,
    fill: "#5E17EB",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 40,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 68,
    r: 3,
    fill: "white",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 68,
    r: 3,
    fill: "white",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 45,
    r: 20,
    fill: "#22CAAC",
    opacity: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 45,
    rx: 20,
    ry: 10,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    opacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 45,
    x2: 160,
    y2: 45,
    stroke: "white",
    strokeWidth: 1.5,
    opacity: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 25,
    x2: 140,
    y2: 65,
    stroke: "white",
    strokeWidth: 1.5,
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45,30 L60,40 L55,45 L50,43 L30,55 L25,50 L45,30",
    fill: "#5E17EB",
    opacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 33,
    r: 2,
    fill: "white",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.77baf027027524299e425d0339b49eb5.svg";
export { ForwardRef as ReactComponent };